import type { NwtTrackingProps, OmitFromUnion } from './use-jobs-nwt-tracking';
import { useJobsNwtTracking } from './use-jobs-nwt-tracking';

type UseBookmarkTrackingResult = (isBookmarked: boolean) => void;

export const useBookmarkTracking = (
  nwtTrackingOptions: OmitFromUnion<NwtTrackingProps, 'event'>
): UseBookmarkTrackingResult => {
  const nwtTrack = useJobsNwtTracking();

  return (isBookmarked: boolean) => {
    nwtTrack({
      ...nwtTrackingOptions,
      event: isBookmarked ? 'unbookmarked' : 'bookmarked',
    });
  };
};
